import FooterPage from './FooterPage.jsx';

export default FooterPage;
